import styled, { css } from 'styled-components';
import { getTypographyIntent, typographyWeights } from '../Typography/Typography.styles';
import { colors } from '../_styles/colors';
import { spacing } from '../_styles/spacing';
export var StyledContainer = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledContainer",
  componentId: "core-12_20_2__sc-1q6nqfz-0"
})(["color:", ";display:flex;align-items:center;a,a:hover{display:inline-flex;text-decoration:none;}"], colors.gray50);
export var StyledList = /*#__PURE__*/styled.ol.withConfig({
  displayName: "StyledList",
  componentId: "core-12_20_2__sc-1q6nqfz-1"
})(["display:flex;margin:0;padding-left:0;"]);
export var StyledSeparator = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSeparator",
  componentId: "core-12_20_2__sc-1q6nqfz-2"
})(["align-items:center;display:inline-flex;justify-content:center;margin:0px ", "px;"], spacing.xs);
export var StyledCrumb = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledCrumb",
  componentId: "core-12_20_2__sc-1q6nqfz-3"
})(["", " align-items:center;color:", ";display:inline-flex;min-height:24px;text-decoration:none;&:hover{cursor:", ";text-decoration:", ";}> a{color:", ";", "}", ""], getTypographyIntent('body'), colors.gray45, function (_ref) {
  var active = _ref.active;
  return active ? 'default' : 'pointer';
}, function (_ref2) {
  var active = _ref2.active;
  return active ? 'none' : 'underline';
}, colors.gray45, function (_ref3) {
  var active = _ref3.active;
  return active && css(["color:", ";font-weight:", ";"], colors.gray15, typographyWeights.semibold);
}, function (_ref4) {
  var active = _ref4.active;
  return active && css(["color:", ";font-weight:", ";"], colors.gray15, typographyWeights.semibold);
});
//# sourceMappingURL=Breadcrumbs.styles.js.map